import { render } from "./IconDelete.vue?vue&type=template&id=4626401a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconDelete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4626401a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4626401a', __exports__)) {
    api.reload('4626401a', __exports__)
  }
  
  module.hot.accept("./IconDelete.vue?vue&type=template&id=4626401a", () => {
    api.rerender('4626401a', render)
  })

}


export default __exports__